import type { MiddlewareContext } from "@/router/index";

export default async function claim(context: MiddlewareContext) {
  const { next } = context;
  const { useUser } = await import("@/stores/user/user");

  if (context.to.meta.claim) {
    const userStore = useUser();

    const hasClaim = userStore.hasClaim(context.to.meta.claim.toString());

    if (!hasClaim) {
      return next({ name: "permissionDenied" });
    }
  }

  return next();
}
